import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { TableAccountingStyled } from "./styled";

const TableAccounting = ({ theme_standard, data }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  // Format number with comma
  const formatNumber = (num) => {
    if (num === null || num === undefined || num === "") return "";
    if (num === 0) return "";
    return num.toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // ถ้าไม่มีข้อมูล
  if (!data || !data.columns || !data.rows) {
    return (
      <TableAccountingStyled className={customClass}>
        <div>ไม่พบข้อมูล</div>
      </TableAccountingStyled>
    );
  }

  const { columns, rows } = data;

  // สร้าง room columns (ไม่รวม type, label, total)
  const roomColumns = columns.filter(
    (col) => !["type", "label", "total"].includes(col.key)
  );

  // หา row ตาม type
  const getRowByType = (type) => rows.find((r) => r.type === type) || {};

  // สร้างข้อมูลสำหรับแต่ละ section
  const sections = [
    {
      type: "A",
      title: "ยอดรับล่วงหน้ายกมา",
      titleRow: getRowByType("A"),
      subRows: [
        { label: "เงินมัดจำที่ได้รับแล้ว", data: getRowByType("A") },
      ],
    },
    {
      type: "B",
      title: "ยอดรับชำระจากลูกค้าทุกช่องทาง",
      titleRow: getRowByType("B"),
      subRows: [
        { label: "ยอดเงินรับจากลูกค้า", data: getRowByType("B") },
      ],
    },
    {
      type: "C",
      title: "รายได้รับรู้แล้ว",
      titleRow: {
        total: (getRowByType("C1").total || 0) + (getRowByType("C2").total || 0),
      },
      subRows: [
        { label: "ค่าเช่าห้อง", data: getRowByType("C1") },
        { label: "ค่าบริการเพิ่ม", data: getRowByType("C2") },
      ],
    },
    {
      type: "E",
      title: "เงินรับล่วงหน้า(คงเหลือ)",
      titleRow: getRowByType("E"),
      subRows: [
        { label: "เงินจองห้องล่วงหน้า", data: getRowByType("E") },
      ],
    },
  ];

  return (
    <TableAccountingStyled className={customClass}>
      <div className="table_scroll_x">
      <table className="table_accounting">
        <thead>
          <tr>
            <th className="table_header type_col"></th>
            <th className="table_header">รายการ</th>
            <th className="table_header">รวม</th>
            {roomColumns.map((col, idx) => (
              <th key={idx} className="table_header">
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sections.map((section, sectionIdx) => (
            <React.Fragment key={sectionIdx}>
              {/* Title Row */}
              <tr className="section_title_row">
                <td className="table_detail type_col bold_black">{section.type}</td>
                <td className="table_detail bold_black">{section.title}</td>
                <td className={`table_detail text_right ${section.type === "C" ? "bold_black" : ""}`}>
                  {!["A", "B", "E"].includes(section.type) && formatNumber(section.titleRow.total)}
                </td>
                {roomColumns.map((col, colIdx) => (
                  <td key={colIdx} className="table_detail text_right">
                    {!["A", "B", "E"].includes(section.type) && formatNumber(section.titleRow[col.key])}
                  </td>
                ))}
              </tr>
              {/* Sub Rows */}
              {section.subRows.map((subRow, subIdx) => (
                <tr key={subIdx}>
                  <td className="table_detail type_col"></td>
                  <td className="table_detail sub_label">{subRow.label}</td>
                  <td className="table_detail text_right">
                    {formatNumber(subRow.data?.total)}
                  </td>
                  {roomColumns.map((col, colIdx) => (
                    <td key={colIdx} className="table_detail text_right">
                      {formatNumber(subRow.data?.[col.key])}
                    </td>
                  ))}
                </tr>
              ))}
              {/* Spacer Row */}
              <tr className="spacer_row">
                <td className="table_detail spacer" colSpan={3 + roomColumns.length}></td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
      </div>
    </TableAccountingStyled>
  );
};

TableAccounting.propTypes = {};

export default TableAccounting;
